import { DeleteOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { t_hospital_visit } from 'types';

type Props = {
  data: any;
  handleDelete: any;
  statusBill: boolean | undefined;
};

const TableDetail = ({ data, handleDelete, statusBill }: Props) => {
  const columns: any = [
    {
      title: 'No.',
      dataIndex: 'name',
      key: 'name',
      width: '5%',
      align: 'center',
      render(text: string, _row: any, index: number) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{index + 1}</div>,
        };
      },
    },
    {
      title: 'ID',
      dataIndex: 'patient_id',
      key: 'patient_id',
      width: '10%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: 'ご利用者名',
      dataIndex: 'cpap_id',
      key: 'cpap_id',
      width: '15%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: 'CPAP請求月',
      key: 'target_month',
      dataIndex: 'target_month',
      width: '15%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text ? `${text.slice(0, 4)}年${Number(text.slice(4))}月` : ''}</div>,
        };
      },
    },
    {
      title: '備考',
      key: 'hospital_visit_remark',
      dataIndex: 'hospital_visit_remark',
      width: '40%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left', paddingLeft: '10px' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '',
      key: 'button',
      dataIndex: 'button',
      width: '10%',
      align: 'center',
      render(text: string, row: t_hospital_visit) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'center', borderLeft: '2px solid white' },
            className: 'standardFont',
          },
          children: (
            <div
              style={{
                backgroundColor: '#F6F6F6',
                width: '65px',
                color: 'black',
                border: 'none',
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
              }}
            >
              {statusBill ? null : (
                <>
                  削除
                  <DeleteOutlined
                    onClick={() => {
                      handleDelete(row);
                    }}
                    style={{ marginBottom: '4px' }}
                  />
                </>
              )}
            </div>
          ),
        };
      },
    },
  ];

  return (
    <div>
      <Table columns={columns} dataSource={data} pagination={false} />
    </div>
  );
};

export default TableDetail;
